export const CUSTOMS_PHONE_WARNING = 'CUSTOMS_PHONE_WARNING';
export const CUSTOMS_EEL_PFC_WARNING = 'CUSTOMS_EEL_PFC_WARNING';
export const CUSTOMS_DESCRIPTION_LENGTH_WARNING = 'CUSTOMS_DESCRIPTION_LENGTH_WARNING';
export const UPS_LARGE_PACKAGE_SURCHARGE = 'UPS_LARGE_PACKAGE_SURCHARGE';
